exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://cdn.quilljs.com/1.3.6/quill.snow.css);", ""]);

// Module
exports.push([module.id, "/* @import '@/styles/variables.scss'; */\n\n.markupContainer {\n  div.ql-toolbar.ql-snow {\n    border-top: 0;\n    border-left: 0;\n    border-right: 0;\n    border-radius: 0;\n  }\n\n  div.ql-container {\n    overflow-x: auto;\n    border-left: 0;\n    border-right: 0;\n  }\n}\n", ""]);

